module.exports = __webpack_public_path__ + "static/media/condiciones_uso_JCA.1729b834.pdf";